module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-backoffice-zone-list component-backoffice-category-list"
  }, [_c('div', {
    staticClass: "row column"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.zones), function(zone, index) {
    return _c('div', {
      staticClass: "column small-12 large-6 category"
    }, [_c('div', {
      staticClass: "inner-content card"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "column shrink"
    }, [_c('dropdown', {
      attrs: {
        "icon": 'fa fa-ellipsis-v fa-2x action',
        "position": 'top'
      }
    }, [_c('div', {
      staticClass: "dropdown-buttons"
    }, [_c('a', {
      staticClass: "button",
      on: {
        "click": _vm.deleteZone
      }
    }, [_vm._v("Delete")]), _c('ModalReveal', {
      ref: "revealGeoJson",
      refInFor: true
    }, [_c('button', {
      staticClass: "button",
      attrs: {
        "slot": "trigger"
      },
      on: {
        "click": _vm.showGeoJson
      },
      slot: "trigger"
    }, [_vm._v("Copy GeoJson to clipboard")]), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "column"
    }, [(_vm.spin) ? _c('loading-spinner') : _c('textarea', {
      attrs: {
        "id": "geoJsonToCopy",
        "rows": "30"
      },
      domProps: {
        "value": _vm.geoJson
      }
    })], 1)]), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "column"
    }, [_c('button', {
      staticClass: "button",
      attrs: {
        "disabled": _vm.geoJson === ''
      },
      on: {
        "click": _vm.copyToClipboard
      }
    }, [_vm._v("Copy to clipboard")])])])])], 1)])], 1), _c('div', {
      staticClass: "column"
    }, [_c('div', [_vm._v("Z" + _vm._s(zone.id))]), _c('div', [_c('router-link', {
      attrs: {
        "to": {
          name: 'edit-zone',
          params: {
            id: zone.id
          }
        }
      }
    }, [_c('h3', [_vm._v(_vm._s(zone.name) + "  ")])])], 1)])])])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-863dcf12!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/ZoneList.vue
// module id = 2625
// module chunks = 1